export default "__VITE_ASSET__5a0db74f__"